import { useTheme } from '@mui/material';

import { SideNavigationState, useSideNavigationModeContext } from './context';

export function useSideNavigationAnimation() {
  const theme = useTheme();
  const { sideNavigationState } = useSideNavigationModeContext();

  const sideNavigationEnteringAndLeavingAnimation = {
    transition: theme.transitions.create(['width'], {
      easing: theme.transitions.easing.sharp,
      duration:
        sideNavigationState === SideNavigationState.Collapsed
          ? theme.transitions.duration.leavingScreen
          : theme.transitions.duration.enteringScreen,
    }),
  };

  const sideNavigationOpacityAnimation = {
    opacity: sideNavigationState === SideNavigationState.Expanded ? 1 : 0,
    transition: theme.transitions.create(['opacity'], {
      easing: theme.transitions.easing.sharp,
      duration:
        sideNavigationState === SideNavigationState.Expanded
          ? theme.transitions.duration.enteringScreen
          : theme.transitions.duration.leavingScreen,
    }),
  };
  return {
    sideNavigationEnteringAndLeavingAnimation,
    sideNavigationOpacityAnimation,
  };
}
